import React from "react";

import * as styles from "./styles.css";
import { Props, Typography } from "./Typography";

export const TooltipTypography = React.forwardRef<HTMLElement, Props>(
  (props, ref) => {
    return <Typography {...props} ref={ref} className={styles.tooltip} />;
  }
);
